import { render, staticRenderFns } from "./ModalRazao.vue?vue&type=template&id=41336162&scoped=true"
import script from "./ModalRazao.vue?vue&type=script&lang=js"
export * from "./ModalRazao.vue?vue&type=script&lang=js"
import style0 from "./ModalRazao.vue?vue&type=style&index=0&id=41336162&prod&lang=scss&scoped=true"
import style1 from "./ModalRazao.vue?vue&type=style&index=1&id=41336162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41336162",
  null
  
)

export default component.exports